import { createSlice } from '@reduxjs/toolkit';
import type { PayloadAction } from '@reduxjs/toolkit';
import {
  createCreditApplicationExtraReducer,
  createManualUploadCreditApplicationExtraReducer,
  getApplicationHistoryExtraReducer,
  getCreditApplicationExtraReducer,
  getCreditApplicationPDFExtraReducer,
  getCreditApplicationsExtraReducer,
  updateCreditApplicationExtraReducer,
  getSupplierCreditApplicationExtraReducer,
  makeCreditAppSignatureExtraReducer,
  sendReferencesCreditApplicationExtraReducer,
  updateSupplierCreditApplicationExtraReducer,
  editCreditApplicationDataExtraReducer,
  sendFeedbackCreditApplicationExtraReducer,
  resolveFeedbackCreditApplicationExtraReducer,
  taxExemptReviewExtraReducer,
  sendCreditApplicationTemplateLinkExtraReducer,
  resendRequestCreditAppSignatureExtraReducer,
  requestSignatureDetailsUpdateExtraReducer,
  requestUpdateCreditApplicationExtraReducer,
  createApplicationUpdateHistoryExtraReducer,
  updateApplicationUpdateHistoryExtraReducer,
  refreshPlaidReportApplicationExtraReducer,
  internalApproveCreditApplicationExtraReducer,
  sendBankReferenceExtraReducer,
  updateBankReferenceResponseExtraReducer,
} from '../reducers/creditApplicationsReducers';
import { CreditApplication } from '@dill/dill-shared';

export interface CreditApplicationsInitialState {
  loadingList: string[];
  creditApplications: CreditApplication[];
  archivedCreditApplications: CreditApplication[];
  creditApplication: CreditApplication | null;
}

const initialState: CreditApplicationsInitialState = {
  loadingList: [],
  creditApplications: [],
  archivedCreditApplications: [],
  creditApplication: null,
};

export const creditApplicationsSlice = createSlice({
  name: 'creditApplications',
  initialState,
  reducers: {
    resetCreditApplicationsRootState: () => initialState,
    setCreditApplication: (state, action: PayloadAction<CreditApplication | null>) => {
      state.creditApplication = action.payload;
    },
  },
  extraReducers(builder) {
    createCreditApplicationExtraReducer(builder);
    createManualUploadCreditApplicationExtraReducer(builder);
    getApplicationHistoryExtraReducer(builder);
    getCreditApplicationExtraReducer(builder);
    getCreditApplicationsExtraReducer(builder);
    updateCreditApplicationExtraReducer(builder);
    updateApplicationUpdateHistoryExtraReducer(builder);
    getCreditApplicationPDFExtraReducer(builder);
    getSupplierCreditApplicationExtraReducer(builder);
    makeCreditAppSignatureExtraReducer(builder);
    sendReferencesCreditApplicationExtraReducer(builder);
    sendFeedbackCreditApplicationExtraReducer(builder);
    resolveFeedbackCreditApplicationExtraReducer(builder);
    taxExemptReviewExtraReducer(builder);
    updateSupplierCreditApplicationExtraReducer(builder);
    editCreditApplicationDataExtraReducer(builder);
    sendCreditApplicationTemplateLinkExtraReducer(builder);
    requestUpdateCreditApplicationExtraReducer(builder);
    resendRequestCreditAppSignatureExtraReducer(builder);
    requestSignatureDetailsUpdateExtraReducer(builder);
    createApplicationUpdateHistoryExtraReducer(builder);
    refreshPlaidReportApplicationExtraReducer(builder);
    internalApproveCreditApplicationExtraReducer(builder);
    sendBankReferenceExtraReducer(builder);
    updateBankReferenceResponseExtraReducer(builder);
  },
});

export const { resetCreditApplicationsRootState, setCreditApplication } =
  creditApplicationsSlice.actions;
